// mixins / shorthands

import { css } from "styled-components";

type ShadeLevel = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const primaryShade = (index: ShadeLevel) =>
  css`
    ${({ theme }) => theme.vstui.color.primary.getShade(index)}
  `;

export const secondaryShade = (index: ShadeLevel) =>
  css`
    ${({ theme }) => theme.vstui.color.secondary.getShade(index)}
  `;

export const baseShade = (index: ShadeLevel) =>
  css`
    ${({ theme }) => theme.color.base.getShade(index)}
  `;

export const clampLines = (lineCount: number) => css`
  overflow: hidden;
  text-overflow: ellipsis;
  /* stylelint-disable property-no-vendor-prefix -- clamp is well supported */
  /* stylelint-disable value-no-vendor-prefix -- using these prefixes */
  display: -webkit-box;
  -webkit-line-clamp: ${lineCount};
  -webkit-box-orient: vertical;
  /* stylelint-enable value-no-vendor-prefix */
  /* stylelint-enable property-no-vendor-prefix */
`;

export const visuallyHidden = css`
  position: absolute;
  clip: rect(1px 1px 1px 1px);
  /* for Internet Explorer */
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  white-space: nowrap;
  overflow: hidden;
`;

export const emojiFont = css`
  font-family: Segoe UI Emoji, sans-serif;
`;

export const onePixelImageData =
  "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs";

export const fadeInOut = (isVisible) => {
  const durationMS = 200;

  if (isVisible) {
    return css`
      opacity: 1;
      visibility: visible;
      transition: opacity ${durationMS}ms ease-in-out, visibility 0s;
    `;
  }
  return css`
    opacity: 0;
    visibility: hidden;
    transition: opacity ${durationMS}ms ease-in-out, visibility ${durationMS}ms;
  `;
};

export const scaleUp = (isVisible) => {
  const durationMS = 300;

  if (isVisible) {
    return css`
      visibility: visible;
      transition: transform ${durationMS}ms;
      transform: scale(1);
    `;
  }
  return css`
    visibility: hidden;
    transform: scale(0.5);
  `;
};

export const prettyHTML = css`
  a {
    text-decoration: underline;
    color: ${primaryShade(6)};
    font-weight: 500;
    border-radius: 4px;
    border: 2px solid transparent;
    &:focus {
      outline: none;
      box-shadow: ${primaryShade(6)} 0px 0px 0px 2px;
    }
  }
  p {
    margin: 12px 0;
  }
  i,
  em {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
`;
